class ReportsCounter {
	constructor(element) {
		this.element = element;
		this.buttons = [...element.querySelectorAll('.js-reports-counter-year')];
		this.totalElement = element.querySelector('.js-reports-counter-total');
		this.percentElement = element.querySelector('.js-reports-counter-percent');
		this.firstLabelElement = element.querySelector('.js-reports-counter-first-label');
		this.secondLabelElement = element.querySelector('.js-reports-counter-second-label');
		this.thirdElement = element.querySelector('.js-reports-counter-third');

		this.years = this.parseYears();
		this.firstLabelTpl = element.dataset.firstLabel || 'zgłoszeń w {year} roku';
		this.secondLabelTpl = element.dataset.secondLabel || 'wzrost\nwzględem {previous_year} roku';
		this.currentYear = element.dataset.selectedYear || this.getDefaultYear();
		this.inViewport = false;

		this.bindEvents();
		this.initObserver();
	}

	parseYears() {
		try {
			return JSON.parse(this.element.dataset.years || '{}');
		} catch (e) {
			return {};
		}
	}

	getDefaultYear() {
		const years = Object.keys(this.years).sort();

		for (let i = years.length - 1; i >= 0; i--) {
			if (this.years[years[i]] !== null) {
				return years[i];
			}
		}

		return years[years.length - 1] || '';
	}

	bindEvents() {
		this.buttons.forEach((btn) => {
			btn.addEventListener('click', () => {
				this.setActiveYear(btn.dataset.year, true);
			});
		});
	}

	initObserver() {
		const observer = new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting && !this.inViewport) {
					this.inViewport = true;
					this.setActiveYear(this.currentYear, true);
					this.animateThird();
					observer.disconnect();
				}
			},
			{ threshold: 0.2 },
		);

		observer.observe(this.element);
	}

	setActiveYear(year, animate = false) {
		this.currentYear = year;

		this.buttons.forEach((btn) => {
			btn.classList.toggle('is-active', btn.dataset.year === year);
		});

		const data = this.years[year];

		if (data === null || data === undefined) {
			if (this.totalElement) this.totalElement.textContent = '—';
			if (this.percentElement) this.percentElement.textContent = '—';
			this.updateLabels(year, null);
			return;
		}

		const total = data.total || 0;
		const percent =
			data.percent !== null && data.percent !== undefined ? Math.round(data.percent) : null;
		const previousYear = data.previousYear || '';

		this.updateLabels(year, previousYear);

		if (animate) {
			this.animateCount(this.totalElement, total, false);

			if (percent !== null) {
				this.animateCount(this.percentElement, percent, true);
			} else {
				if (this.percentElement) this.percentElement.textContent = '—';
			}
		} else {
			if (this.totalElement) {
				this.totalElement.textContent = this.formatNumber(total);
			}

			if (this.percentElement) {
				this.percentElement.textContent =
					percent !== null ? this.formatPercent(percent) : '—';
			}
		}
	}

	updateLabels(year, previousYear) {
		if (this.firstLabelElement) {
			this.firstLabelElement.textContent = this.firstLabelTpl.replace('{year}', year);
		}

		if (this.secondLabelElement) {
			const text = this.secondLabelTpl
				.replace('{previous_year}', previousYear || '—')
				.replace('{year}', year);

			this.secondLabelElement.innerHTML = text.replace(/\\n|\n/g, '<br>');
		}
	}

	animateCount(element, targetValue, isPercent) {
		if (!element) return;
//szybkosc
		const duration = 2000;
		const startTime = performance.now();

		const tick = (now) => {
			const elapsed = now - startTime;
			const progress = Math.min(elapsed / duration, 1);
			const eased = 1 - Math.pow(1 - progress, 3);
			const current = Math.round(targetValue * eased);

			element.textContent = isPercent
				? this.formatPercent(current)
				: this.formatNumber(current);

			if (progress < 1) {
				requestAnimationFrame(tick);
			}
		};

		requestAnimationFrame(tick);
	}

	formatNumber(value) {
		return Number(value).toLocaleString('pl-PL');
	}

	formatPercent(value) {
		if (value === null || value === undefined) return '—';
		const n = Number(value);
		if (Number.isNaN(n)) return '—';
		return n > 0 ? `+${n}%` : `${n}%`;
	}

	animateThird() {
		if (!this.thirdElement) return;

		const raw = (this.thirdElement.dataset.value || '').trim();

		// Extract leading number (integer or decimal) and the rest as suffix.
		// e.g. "30 lat" → num=30, suffix=" lat" | "1,5 mln" → num=1.5, suffix=" mln"
		const match = raw.match(/^(\d+(?:[.,]\d+)?)(.*)/);

		if (!match) return; // no number found — nothing to animate

		const target = parseFloat(match[1].replace(',', '.'));
		const suffix = match[2];
		const isDecimal = match[1].includes(',') || match[1].includes('.');
//szybkosc
		const duration = 2000;
		const startTime = performance.now();

		const tick = (now) => {
			const elapsed = now - startTime;
			const progress = Math.min(elapsed / duration, 1);
			const eased = 1 - Math.pow(1 - progress, 3);
			const current = target * eased;

			const display = isDecimal
				? current.toLocaleString('pl-PL', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
				: Math.round(current).toLocaleString('pl-PL');

			this.thirdElement.textContent = display + suffix;

			if (progress < 1) {
				requestAnimationFrame(tick);
			}
		};

		requestAnimationFrame(tick);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-reports-counter').forEach((el) => {
		new ReportsCounter(el);
	});
});
